<template>
    <div class="identityFinish">
        <!-- 中间部分 -->
        <div class="finish-img">
            <img :src="rzcg" alt="">
        </div>
        <div class="finish-title">
            <div class="finish-title-success">实名认证成功！</div>
            <div class="finish-title-goindex">快去首页浏览任务吧</div>
        </div>
        <!-- 按钮 -->
        <div class="finish-goindex">
            <div class="goindex-button" @click="goMyPerson" v-if="formApply.taskNo">返回</div>
            <div class="goindex-button" @click="goMyPerson" v-else>前往首页</div>
        </div>
    </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
    data(){
        return{
            rzcg:require("../../../assets/img/renzhengchenggong.png"),
            formApply:{
                taskNo:"",

            }
        }
    },
    mounted(){
        this.formApply.taskNo=sessionStorage.getItem("taskNo")
    },
    methods:{
        goMyPerson(){
            if(this.formApply.taskNo){
                this.formApply.redirectDomain = config.topDomainName;
                http.post(config.applyH5,this.formApply).then(({code,data,message})=>{
                    if(code===0){
                        if (data.applyResult===2) {
                          // 跳转到signUrl
                          location.href =data.signUrl
                        } else { // 【0 或 1 的情况】
                          if (data.thirdRedirectUrl) {
                            // 跳转到第三方页面
                            location.href =data.thirdRedirectUrl
                        } else {
                            //  返回到申请成功页面
                            this.$router.push({path:"../../applicationSuccess"})
                        }
                    }
                    }else{
                        this.$toast.fail(message)
                    }
                })
            }else{
                this.$router.push({path:'../updateInfo'})
            }
        }
    }
}
</script>
<style lang="less" scoped>
.identityFinish{
    .finish-img{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 112px;
        img{
            width: 325px;
            height: auto;
        }
    }
    .finish-title{
        margin-top: 54px;
        .finish-title-success{
            font-size: 40px;
            color: #222222;
        }
        .finish-title-goindex{
            font-size: 30px;
            color: #ADADAD;
        }
    }
    .finish-goindex{
        display: flex;
        justify-content: center;
        width: 100%;
        .goindex-button{
            width: 90%;
            height: 90px;
            background: #0681FD;
            border-radius: 45px;
            color: #ffffff;
            font-size: 34px;
            line-height: 90px;
            margin-top: 95px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/commonInfo/components/identityFinish.vue